import { createFileRoute } from "@tanstack/react-router";
import { ActiveRideTracking } from "@/components/petmoon/ActiveRideTracking";

export const Route = createFileRoute("/seguimiento")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { mascota?: string } =>
    typeof search['mascota'] === "string" && search['mascota']
      ? { mascota: search['mascota'] as string }
      : {},
  head: () => ({
    meta: [
      { title: "Seguimiento de Viaje en Vivo — PetMoon" },
      {
        name: "description",
        content:
          "Sigue el viaje de tu mascota en tiempo real: ubicación en el mapa, llegada estimada, estado del trayecto y contacto directo con tu conductor PetMoon.",
      },
      { property: "og:title", content: "Seguimiento de Viaje en Vivo — PetMoon" },
      {
        property: "og:description",
        content:
          "Tu peludo está en camino. Revisa su ubicación, la llegada estimada y contacta a tu conductor.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
      { property: "og:url", content: "https://petmoon.mgwebserver.com/seguimiento" },
    ],
    links: [{ rel: "canonical", href: "https://petmoon.mgwebserver.com/seguimiento" }],
  }),
  component: ActiveRideTracking,
});
